import { useQuery } from '@tanstack/react-query';
import { OnlineBackOfficeService } from './online-back-office.service';

export class OnlineBackOfficeQuery {
    useGetTicketCurrentCashout = ({
        accountNumber,
        ticketCode,
        enabled,
    }: {
        accountNumber: string;
        ticketCode: string;
        enabled: boolean;
    }) => {
        return useQuery({
            queryKey: ['onlineBackOffice', { accountNumber, ticketCode }],
            queryFn: () => OnlineBackOfficeService.getTicketCurrentCashout({ accountNumber, ticketCode }),
            refetchInterval: 5000,
            enabled,
        });
    };
}
